import {TourStepSetting} from 'src/app/models/tour/tour-step-settings';
import {EnterpriseTourStep} from 'src/app/models/tour/tour-step-enums/enterprise-tour-step';

export const ENV_NAV_TOUR_STEPS: TourStepSetting[] = [
  {
    id: EnterpriseTourStep.ENV_NAV_WELCOME,
    title: 'Welcome to Your Environment!',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_WELCOME',
    overlay: { radius: 0, padding: 0 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_SIDEBAR,
    title: 'Navigation Menu',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_SIDEBAR',
    anchorSettings: { element: '.sidebar', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 12 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_OVERVIEW,
    title: 'Overview',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_OVERVIEW',
    anchorSettings: { element: '#env-nav-overview', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_ENDPOINTS,
    title: 'Endpoints',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_ENDPOINTS',
    anchorSettings: { element: '#env-nav-endpoints', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_RELEASE_PACKAGE,
    title: 'Release Package',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_RELEASE_PACKAGE',
    anchorSettings: { element: '#env-nav-release-package', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_SFTP,
    title: 'SFTP',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_SFTP',
    anchorSettings: { element: '#env-nav-sftp', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_DATABASE_BACKUP,
    title: 'Database Backup',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_DATABASE_BACKUP',
    anchorSettings: { element: '#env-nav-database-backup', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_PRODUCT_RVTS,
    title: 'Product RVTs',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_PRODUCT_RVTS',
    anchorSettings: { element: '#env-nav-product-rvts', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_SANITY_TEST,
    title: 'Sanity Test',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_SANITY_TEST',
    anchorSettings: { element: '#env-nav-sanity-test', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_EF_TEST,
    title: 'EF Test',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_EF_TEST',
    anchorSettings: { element: '#env-nav-ef-test', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_COB,
    title: 'COB',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_COB',
    anchorSettings: { element: '#env-nav-cob', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_RUNBOOK,
    title: 'Runbook',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_RUNBOOK',
    anchorSettings: { element: '#env-nav-runbook', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_SCHEDULES,
    title: 'Schedules',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_SCHEDULES',
    anchorSettings: { element: '#env-nav-schedules', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_JOBS,
    title: 'Jobs',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_JOBS',
    anchorSettings: { element: '#env-nav-jobs', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_CUSTOM_PACKAGE,
    title: 'Custom Package',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_CUSTOM_PACKAGE',
    anchorSettings: { element: '#env-nav-custom-package', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_SIZING_DOCUMENTS,
    title: 'Sizing Documents',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_SIZING_DOCUMENTS',
    anchorSettings: { element: '#env-nav-sizing-documents', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_ACTIVITY,
    title: 'Activity',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_ACTIVITY',
    anchorSettings: { element: '#env-nav-activity', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_INVENTORY,
    title: 'Inventory',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_INVENTORY',
    anchorSettings: { element: '#env-nav-inventory', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_METRICS,
    title: 'Metrics',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_METRICS',
    anchorSettings: { element: '#env-nav-metrics', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_UPDATE_MANAGER,
    title: 'Update Manager',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_UPDATE_MANAGER',
    anchorSettings: { element: '#env-nav-update-manager', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_LOCAL_CONFIGURATION,
    title: 'Local Configuration',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_LOCAL_CONFIGURATION',
    anchorSettings: { element: '#env-nav-local-configuration', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_SETTINGS,
    title: 'Settings',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_SETTINGS',
    anchorSettings: { element: '#env-nav-settings', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_DEPENDENCY_TREE,
    title: 'Dependency Tree',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_DEPENDENCY_TREE',
    anchorSettings: { element: '#env-nav-dependency-tree', on: 'right-start' },
    offset: { perpendicular: 0, parallel: 8 },
    overlay: { radius: 6, padding: 6 },
    classes: 'env-nav-guide',
    skipDelay: true
  },
  {
    id: EnterpriseTourStep.ENV_NAV_DONE,
    title: 'You\'re All Set!',
    translateKey: 'TOUR.MESSAGES.ENV_NAVIGATION.ENV_NAV_DONE',
    overlay: { radius: 0, padding: 0 },
    classes: 'env-nav-guide',
    skipDelay: true
  }
];
